import { useEffect, useState } from "react";
import { parseCookies } from "nookies";
import { AiFillHome } from "react-icons/ai";
import { FaUser } from "react-icons/fa";
import {
  MdShoppingCart,
  MdAdminPanelSettings,
  MdArticle,
} from "react-icons/md";
import { Link, NavLink } from "react-router-dom";

import Popup from "../popup";
import { useT } from "../../i18n";
import Tip from "../shared/tip";
import { useUser } from "../../context/user.context";
import styles from "./header.module.scss";

const Header = () => {
  const { logout, user, fetchUserDetails } = useUser();
  const t = useT();
  const [isOpen, setIsOpen] = useState(false);
  const { accessToken } = parseCookies(null);
  const role = user?.role ?? sessionStorage.getItem("role") ?? "";
  const isAdmin = role === "ROLE_ADMIN";
  const avatar = user?.profileImageUrl;

  // The header is on every page, so it loads the user itself — otherwise the
  // avatar only appears on the few screens that fetch the user themselves.
  useEffect(() => {
    if (accessToken && !user) fetchUserDetails();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [accessToken, user]);

  const options = [
    { title: t("header.support"), icons: ["support"], path: "/?support=true" },
    { title: t("header.profileSettings"), icons: ["profile"], path: "settings" },
  ];

  return (
    <>
      <div className={styles.header}>
        <Tip label={t("header.home")} side="bottom">
          <NavLink
            className={({ isActive }) =>
              isActive ? styles.activeClassName : undefined
            }
            to="/"
          >
            <AiFillHome />
          </NavLink>
        </Tip>
        <Tip label={t("header.shop")} side="bottom">
          <NavLink
            className={({ isActive }) =>
              isActive ? styles.activeClassName : undefined
            }
            to="shop"
          >
            <MdShoppingCart />
          </NavLink>
        </Tip>
        <Tip label={t("header.account")} side="bottom">
          <NavLink
            className={({ isActive }) =>
              isActive ? styles.activeClassName : undefined
            }
            to="accounts"
          >
            <FaUser />
          </NavLink>
        </Tip>
        {!!accessToken && (
          <Tip label={t("header.menu")} side="bottom">
            <button
              type="button"
              onClick={() => setIsOpen(true)}
              className="bg-transparent border-0 p-0 flex items-center"
            >
              {avatar ? (
                <img
                  src={avatar}
                  alt=""
                  className="w-[26px] h-[26px] rounded-full object-cover border border-primary"
                />
              ) : (
                <img src="/logo-badge.png" alt="" className="w-[26px] h-[26px]" />
              )}
            </button>
          </Tip>
        )}
      </div>
      {isOpen && (
        <Popup
          setIsOpen={setIsOpen}
          className="bg-transparent backdrop-blur-none"
          contentClass="absolute right-0 top-14 my-0 mx-0 w-max shadow-lg"
        >
          <div className={styles.content}>
            {options.map((item, index) => (
              <Link key={index} to={item.path} onClick={() => setIsOpen(false)}>
                <img src={`/${item.icons[0]}.svg`} alt="logo" />
                <span>{item.title}</span>
              </Link>
            ))}

            <Link to="blog" onClick={() => setIsOpen(false)}>
              <MdArticle size={21} />
              <span>{t("header.blog")}</span>
            </Link>

            {isAdmin && (
              <Link to="admin" onClick={() => setIsOpen(false)}>
                <MdAdminPanelSettings size={21} />
                <span>{t("header.admin")}</span>
              </Link>
            )}

            <div onClick={logout}>
              <img src="/logOut.svg" alt="logo" />
              <span>{t("header.signOut")}</span>
            </div>
          </div>
        </Popup>
      )}
    </>
  );
};

export default Header;
